var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganizationoffcanvas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490.1 490.1",
    style: {
      enableBackground: "new 0 0 490.1 490.1"
    },
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    fill: "#00b4b6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M195.75,247.3v-70.7c0-3.3-1.7-6.4-4.4-8.2c-6.5-4.3-10.3-11.5-10.3-19.2V75.9    c0-30.9,25.2-56.1,56.1-56.1h15.8c30.9,0,56.1,25.2,56.1,56.1v73.3c0,7.7-3.9,14.9-10.3,19.2c-2.8,1.8-4.4,4.9-4.4,8.2v70.7    c0,5,2.9,9.6,7.4,11.8c9.3,4.5,57.7,29,102.3,65.7c5.9,4.9,9.3,12.1,9.3,19.8v50.2c0,5.5,4.4,9.9,9.9,9.9s9.9-4.4,9.9-9.9v-50.2    c0-13.7-6-26.5-16.5-35.1c-42-34.5-87.2-58.6-102.5-66.3v-61.7c9.3-8.1,14.7-19.8,14.7-32.4V75.9c0-41.9-34-75.9-75.9-75.9h-15.8    c-41.9,0-75.9,34-75.9,75.9v73.3c0,12.5,5.4,24.3,14.7,32.4v61.7c-15.2,7.7-60.5,31.8-102.5,66.3c-10.5,8.6-16.5,21.4-16.5,35.1    v50.2c0,5.5,4.4,9.9,9.9,9.9s9.9-4.4,9.9-9.9v-50.2c0-7.7,3.4-14.9,9.3-19.8c44.6-36.7,93.1-61.1,102.3-65.7    C192.85,256.9,195.75,252.3,195.75,247.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M269.25,257.7c-5.5,0-9.9,4.4-9.9,9.9c0,4.2-1.8,7.9-4.6,10.5c-0.6,0.4-1.2,0.8-1.7,1.4    c-2.3,1.5-5.1,2.5-8,2.5c-7.9,0-14.4-6.4-14.4-14.4c0-5.5-4.4-9.9-9.9-9.9s-9.9,4.4-9.9,9.9c0,8.1,2.8,15.5,7.6,21.4l-7.3,169.7    c-0.1,2.9,1.1,5.8,3.3,7.8l23.3,21c1.9,1.7,4.3,2.6,6.6,2.6c2.4,0,4.8-0.9,6.6-2.6l23.6-21.3c2.2-2,3.4-4.8,3.3-7.8l-7.6-167.7    c5.6-6.1,9-14.2,9-23C279.15,262.1,274.65,257.7,269.25,257.7z M244.15,466.8l-13.2-11.9l6.6-153.9c2.4,0.5,4.8,0.8,7.3,0.8    c2,0,3.9-0.2,5.8-0.5l6.9,153.3L244.15,466.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationoffcanvas);
export default __webpack_public_path__ + "static/media/organizationoffcanvas.433bf6aa6415c9d8a30d3d6d62df40b4.svg";
export { ForwardRef as ReactComponent };